import 'bootstrap/dist/css/bootstrap.css';
import "vue3-treeview/dist/style.css";
// font dei template (Manrope è anche il font dell'interfaccia)
import '@shared/fonts/fonts.css';
import './css/style.css';
import './filters';


import router from './router'
import store from './store'
import modalPlugin from './plugins/modalPlugin';
import FILTERS from '@/filters';

import App from '@/App.vue';
import { CommonServices } from '@/services/CommonServices'
import { createApp } from 'vue';
import loadComponents from './componentsLoader';
import ModalsContainer from './plugins/modalPlugin/opModalContainer.vue';
import { ModalServices } from './services/ModalServices';

CommonServices.showSpinnerCb = () => {
    store.state.showSpinner++;
}
CommonServices.hideSpinnerCb = () => {
    store.state.showSpinner--;
    if(store.state.showSpinner < 0){
        store.state.showSpinner = 0;
    }
}
CommonServices.unauthorizedCb = () => {
    // L'utente entra solo dal link con il guid: senza token valido non c'è altro modo di rientrare
    if(router.currentRoute.value.path != '/login')
        router.replace('/login');
}
CommonServices.validationErrorsCb = (errors) => {
    ModalServices.validationErrorModal(errors);
}

router.afterEach((to, from) => {
    store.state.pageTitle = <string>to.meta.title;
});

const app = createApp(App)
    .use(store)
    .use(router)
    .use(modalPlugin);

app.config.globalProperties.$filters = FILTERS;

loadComponents(app);

app.component('opModalContainer', ModalsContainer)

app.mount('#app');